module.exports = __webpack_public_path__ + "img/bg-topup.f682b7bd.svg";